import { FunctionComponent } from 'react'
import { Tooltip } from '@black-bear-energy/rucksack'
import { displayActualOrEstimatedDate } from '../helpers/displayActualOrEstimatedDate'

export const ActualOrEstimatedDate: FunctionComponent<
  ActualOrEstimatedDateProps
> = ({ actualDate, estimatedDate }) => {
  const display = displayActualOrEstimatedDate(actualDate, estimatedDate) ?? '—'

  if (actualDate || !estimatedDate) {
    return <>{display}</>
  }

  return (
    <Tooltip
      title="Estimated date"
      placement="bottom"
      slotProps={{
        tooltip: {
          sx: {
            marginTop: '4px !important',
            marginBottom: '4px !important',
          },
        },
      }}
    >
      <span>{display}</span>
    </Tooltip>
  )
}

interface ActualOrEstimatedDateProps {
  actualDate: Date | null
  estimatedDate: Date | null
}
